export default __webpack_public_path__ + "static/media/pass-percent-indicator.15109cc9.svg";